export default {
  state: {
    langLogList: JSON.parse(window.localStorage.getItem('langLogList'))
      ? JSON.parse(window.localStorage.getItem('langLogList'))
      : []
  },
  actions: {
    setLangList({ commit }, langLogList) {
      commit('SET_LANG_LIST', langLogList);
    }
  },
  mutations: {
    SET_LANG_LIST: (state, array) => {
      state.langLogList = array;
      window && window.localStorage.setItem('langLogList', JSON.stringify(array));
    }
  }
};
